import React, { useState } from "react";
import styles from "./Footer.module.css";

function SocialShareIcons({settings}) {
  const [selectedItem, setSelectedItem] = useState("");

  const iconChange = (name) => {
    setSelectedItem(name);
  };

  return (
    <div className={styles.socialIcons}>
      <img
        src={
          selectedItem == "facebook"
            ? "/img/bodyshop/fb-black.svg"
            : "/img/bodyshop/fb-icon.svg"
        }
        alt="Social Icon 1"
        className={styles.socialIcon}
        onMouseEnter={() => iconChange("facebook")}
        onMouseLeave={()=>setSelectedItem("")}
        onClick={()=>window.open(settings?.facebookLink,'_blank')}
      />
      <img
        src={
          selectedItem == "twitter"
            ? "/img/bodyshop/twitter-black.svg"
            : "/img/bodyshop/twitter-icon.svg"
        }
        alt="Social Icon 2"
        className={styles.socialIcon}
        onMouseEnter={() => iconChange("twitter")}
        onMouseLeave={()=>setSelectedItem("")}
        onClick={()=>window.open(settings?.twitterLink,'_blank')}
      />
      <img
        src={
          selectedItem == "instagram"
            ? "/img/bodyshop/insta-black.svg"
            : "/img/bodyshop/ig-icon.svg"
        }
        alt="Social Icon 3"
        className={styles.socialIcon}
        onMouseEnter={() => iconChange("instagram")}
        onMouseLeave={()=>setSelectedItem("")}
        onClick={()=>window.open(settings?.instagramLink,'_blank')}
      />
      <img
        src={
          selectedItem == "linkedin"
            ? "/img/bodyshop/linkedin-black.svg"
            : "/img/bodyshop/linkedin-icon.svg"
        }
        alt="Social Icon 4"
        className={styles.socialIcon}
        onMouseEnter={() => iconChange("linkedin")}
        onMouseLeave={()=>setSelectedItem("")}
        onClick={()=>window.open(settings?.linkedinLink,'_blank')}
      />
    </div>
  );
}

export default SocialShareIcons;
